import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=da227648&scoped=true&"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordForm.vue?vue&type=style&index=0&id=da227648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da227648",
  null
  
)

export default component.exports